import { BottomSheet, BottomSheetLoadingContent } from "@clipboard-health/ui-components";
import { type UseModalState } from "@clipboard-health/ui-components";
import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { DialogContent } from "@mui/material";

interface SubmittingLicenseBottomSheetProps {
  modalState: UseModalState;
}

export function SubmittingLicenseBottomSheet(props: SubmittingLicenseBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      modalState={modalState}
      paperSx={{
        ...getSafeAreaPaddings({ bottom: true }),
      }}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <BottomSheetLoadingContent
          title="Submitting license"
          // todo: make description optional in ui-components
          description=""
        />
      </DialogContent>
    </BottomSheet>
  );
}
